import type { ChakraStylesConfig } from 'chakra-react-select';

// Structural only — takes the list out of its floating layer. Callers keep their own look.
export const inlineMenuChakraStyles: ChakraStylesConfig = {
  // An inline list is always open, so there is nothing for the toggle to do.
  dropdownIndicator: () => ({
    display: 'none',
  }),
  menu: provided => ({
    ...provided,
    position: 'relative',
    boxShadow: 'none',
    marginBottom: 0,
  }),
  menuList: provided => ({
    ...provided,
    boxShadow: 'none',
  }),
};
